// extracted by mini-css-extract-plugin
module.exports = {"createContainer":"receive_createContainer__xhZYc","container":"receive_container__1s95L","headerIcon":"receive_headerIcon__2Ducq","keyText":"receive_keyText__3iqqf"};